<template>
  <div>
    <ProductFilters
      v-if="showFilters"
      :productId.sync="payload.productId"
      :brandId.sync="payload.brandId"
      :supplierId.sync="payload.supplierId"
      :statusId.sync="payload.statusId"
      @apply="getProducts(payload)"
      :action="selected.length > 0"
    />
    <loading v-show="loading" />
    <v-card elevation="4" v-show="!loading">
      <v-app-bar flat dense elevation="0" color="transparent">
        <v-toolbar-title> <h4>Products</h4> </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-app-bar>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <template>
          <v-data-table
            :headers="headers"
            :items="products"
            show-select
            v-model="selected"
            :server-items-length="totalItems"
            :options.sync="pagination"
            :items-per-page="pagination.itemsPerPage"
            @pagination="updatePagination"
            :disable-pagination="false"
            :footer-props="{
              disablePagination: false,
              disableItemsPerPage: false
            }"
            class="elevation-0 black--text"
            @click:row="edit($event.id)"
          >
            <template v-slot:header.data-table-select="{ props, on }">
              <!-- COLOR Not working when props.indeterminate is true -->
              <v-simple-checkbox
                color="primary"
                v-ripple
                v-bind="props"
                v-on="on"
              ></v-simple-checkbox>
            </template>
            <template v-slot:item.data-table-select="{ isSelected, select }">
              <v-simple-checkbox
                color="primary"
                v-ripple
                :value="isSelected"
                @input="select($event)"
              ></v-simple-checkbox>
            </template>
            <template v-slot:item.image="{ item }">
              <v-avatar
                v-for="(image, index) in item.images"
                :key="image.id"
                :style="{ marginLeft: index === 0 ? '0px' : '-35px' }"
              >
                <img :src="image.imageUrl" alt="John" />
              </v-avatar>
            </template>

            <!-- <template v-slot:item.approved="{ item }">
            <v-switch
              @change="toggleApproved($event, item.id)"
              color="green"
              v-model="item.approved"
            ></v-switch>
          </template> -->

            <template v-slot:item.action="{ item }" v-if="actions">
              <v-menu offset-y bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn dark icon v-bind="attrs" v-on="on">
                    <v-icon class="gray--text">more_vert</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item link>
                    <v-list-item-title @click="edit(item.id)"
                      >Edit</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item link>
                    <v-list-item-title @click="deleteAndRefresh(item.id)"
                      >Delete</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>

            <template v-slot:item.amount="{ item }">
              {{ parseFloat(item.amount).toFixed(2) }}
            </template>
          </v-data-table>
        </template>
        <v-divider></v-divider>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
// eslint max-nested-callbacks: ["error", 10]
import Helpers from "@/mixins/helpers.js";
import ProductFilters from "./ProductFilters.vue";
export default {
  components: {
    ProductFilters
  },
  props: {
    payload: {
      type: Object,
      default: () => {
        return {
          from: 0,
          to: 10,
          statusId: null,
          brandId: null,
          supplierId: null
        };
      }
    },
    module: {
      type: String,
      default: "products/LOAD_PRODUCTS"
    },
    actions: {
      type: Boolean,
      default: true
    },
    showFilters: {
      default: true,
      type: Boolean
    }
  },
  mixins: [Helpers],
  data() {
    let vm = this;
    return {
      supplierId: null,
      loading: true,
      selected: [],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: false,
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      headers: [
        {
          text: "",
          align: "left",
          sortable: false,
          value: "image"
        },
        {
          text: "ID",
          align: "left",
          value: "id",
          sortable: false
        },
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Brand",
          align: "left",
          value: "brand.name"
        },
        {
          text: "Supplier",
          align: "left",
          value: "supplier.name"
        },
        { text: "Amount", value: "amount" },
        { text: "", value: "action", align: "right" }
      ]
    };
  },
  computed: {
    products() {
      return this.$store.state.products.products;
    },
    totalItems() {
      return this.$store.state.products.totalProducts;
    }
  },
  watch: {
    selected(val) {
      val.length > 0
        ? this.$emit("enable-action")
        : this.$emit("disable-action");
    }
  },
  created() {
    if (this.actions == false) {
      this.headers = this.headers.filter(column => column.value !== "action");
    }
    setTimeout(() => {
      this.getProducts(this.payload);
    }, 1000);
  },
  methods: {
    getProducts(payLoad) {
      this.loading = true;
      this.$store
        .dispatch(this.module, payLoad)
        .then(response => {
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
          this.$swal("error", error.message, "error");
        });
    },
    updatePagination(pagination) {
      let payLoad = this.payload;
      (payLoad.from =
        pagination.page * pagination.itemsPerPage - pagination.itemsPerPage),
        (payLoad.to =
          pagination.itemsPerPage === -1
            ? this.totalItems
            : pagination.itemsPerPage);
      this.getProducts(payLoad);
    },
    toggleApproved(state, productId) {
      let title = !state ? "Unapproving product..." : "Approving product...";
      let updateText = !state ? "Product unapproved." : "Product approved";
      this.$swal({
        title: title,
        html: "this will only take a moment...",
        onOpen: () => {
          this.$swal.showLoading();
        }
      });

      let payLoad = {
        active: state,
        productId: productId,
        supplierId: this.supplierId
      };

      this.$store
        .dispatch("menu/UPDATE_PRODUCT_APPROVED_STATUS", payLoad)
        .then(response => {
          this.$swal("success", updateText, "success");
        })
        .catch(error => {
          this.$swal("error", error.message, "error");
        });
    },
    async deleteAndRefresh(id) {
      let res = await this.destroy(id);
      if (res) {
        let payLoad = {
          from:
            this.pagination.page * this.pagination.itemsPerPage -
            this.pagination.itemsPerPage,
          to:
            this.pagination.itemsPerPage === -1
              ? this.totalItems
              : this.pagination.itemsPerPage
        };
        this.getProducts(payLoad);
      }
    }
  }
};
</script>
